var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Dialog } from "@mui/material";
import { InfinityLoader } from "../InfinityLoader";
var InfinityLoaderModal = function (_a) {
    var isModalOpen = _a.isModalOpen, fileName = _a.fileName;
    return (_jsx(Dialog, __assign({ fullWidth: true, maxWidth: "sm", open: isModalOpen }, { children: _jsx(InfinityLoader, { fileName: fileName }) })));
};
export { InfinityLoaderModal };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW5maW5pdHlMb2FkZXJNb2RhbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3VpL0luZmluaXR5TG9hZGVyTW9kYWwvSW5maW5pdHlMb2FkZXJNb2RhbC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEsT0FBTyxFQUFFLE1BQU0sRUFBRSxNQUFNLGVBQWUsQ0FBQztBQUN2QyxPQUFPLEVBQUUsY0FBYyxFQUFFLE1BQU0sbUJBQW1CLENBQUM7QUFPbkQsSUFBTSxtQkFBbUIsR0FBRyxVQUFDLEVBQW1EO1FBQWpELFdBQVcsaUJBQUEsRUFBRSxRQUFRLGNBQUE7SUFDbEQsT0FBTyxDQUNMLEtBQUMsTUFBTSxhQUFDLFNBQVMsUUFBQyxRQUFRLEVBQUMsSUFBSSxFQUFDLElBQUksRUFBRSxXQUFXLGdCQUMvQyxLQUFDLGNBQWMsSUFBQyxRQUFRLEVBQUUsUUFBUSxHQUFJLElBQy9CLENBQ1YsQ0FBQztBQUNKLENBQUMsQ0FBQztBQUVGLE9BQU8sRUFBRSxtQkFBbUIsRUFBRSxDQUFDIn0=